import React from "react";
import { Button, Table } from "antd";
import { useRoleModel } from "../roleModel";
import { ColumnsType } from "antd/es/table";
import { DrawerType, IMdRoleDetail } from "../RoleTypes";
import moment from "moment";
import { YhAuth } from "@src/components/auth/YhAuth";



export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, setDrawerVisible,
        setResourceVisible,
        loadResourceByRole,
        setSelectedRowData,
        loadMenuListByRole,
        setEditModel,
        setUserVisible
    } = useRoleModel();


    const columns: ColumnsType<IMdRoleDetail> = [
        {
            align: 'center',
            title: '序号',
            width: 60,
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            title: '角色编号',
            width: 200,
            dataIndex: 'code',
        },
        {
            align: "center",
            title: '角色名称',
            width: 200,
            dataIndex: 'name',
        },
        {
            align: "center",
            title: '使用人数',
            width: 120,
            dataIndex: 'userNum',
        },
        
        {
            align: "center",
            title: '创建人',
            dataIndex: 'createUser',
            width: 100,
        },
        {
            align: "center",
            title: '创建时间',
            width: 200,
            dataIndex: 'createTime',
            render: (value) => moment(value).format("YYYY-MM-DD HH:mm:ss")
        },    
        {
            align: "center",
            title: '角色描述',
            width: 320,
            dataIndex: 'note',
        },
        {
            align: "center",
            title: '状态',
            dataIndex: 'status',
            width: 120,
            render: (v) => v === 0 ? "启用" : "禁用"
        },
        {
            align: "center",
            title: '操作',
            width: 320,
            dataIndex: 'enable',
            fixed: 'right',
            render: (value, record, index) => {
                return (
                    <div>
                        <YhAuth resCode="portal2.au.role.ed">
                            <Button type="link" shape="round" onClick={() => onClick('edit', record)}>编辑</Button>
                        </YhAuth>
                        <YhAuth resCode="portal2.au.role.vw">
                            <Button type="link" shape="round" onClick={() => onClick('resource', record)}>查看资源</Button>
                        </YhAuth>
                        <YhAuth resCode="portal2.au.role.vw">
                            <Button type="link" shape="round" onClick={() => onClick('user', record)}>人员管理</Button>
                        </YhAuth>
                    </div>
                )
            }
        },
    ];

    const onClick = (type: DrawerType, data: IMdRoleDetail) => {
        setSelectedRowData(data)
        loadMenuListByRole(data.code as string)
        loadResourceByRole(data.code as string)
        setEditModel("edit")
        if (type === 'edit') {
            setDrawerVisible(true)
            setResourceVisible(false)
            setUserVisible(false)
        } else if(type === 'resource') {
            setDrawerVisible(false)
            setResourceVisible(true)
            setUserVisible(false)
        } else {
            setDrawerVisible(false)
            setResourceVisible(false)
            setUserVisible(true)
        }
    }

    return (
        <Table
            style={{ cursor: "pointer" }}
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IMdRoleDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            scroll={{ y: '100%', x: 'max-content', scrollToFirstRowOnChange: true }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
        />
    )
}
